<app-sucesso
  *ngIf="tarefaCriadaSucesso"
  [mensagem]="'Tarefa agendada com sucesso!'"
  (continuar)="fecharSucesso()"
/>

<div class="modal-panel-tarefa" *ngIf="!tarefaCriadaSucesso">
  <div class="modal-header">
    <div class="modal-header-left">
      <div class="modal-icon">
        <mat-icon fontSet="material-symbols-outlined">event</mat-icon>
      </div>
      <div>
        <h2 class="modal-title">Agendar tarefa</h2>
        <p class="modal-subtitle">Preencha os campos para agendar uma tarefa</p>
      </div>
    </div>
    <button class="btn-close" type="button" (click)="fechar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body">
    <div class="info-box" *ngIf="contatoInfo?.nome">
      <div class="info-linha">
        <span class="info-nome-destaque">{{ contatoInfo.nome }}</span>
        <span class="info-cargo">{{ contatoInfo.cargo }}</span>
      </div>
      <div class="info-empresa" *ngIf="contatoInfo.empresa">{{ contatoInfo.empresa }}</div>
      <div class="info-email" *ngIf="contatoInfo.email">{{ contatoInfo.email }}</div>
    </div>

    <div class="form-group">
      <label class="form-label" for="responsavel">
        Responsável <span class="required">*</span>
      </label>
      <app-filtro-responsavel
        [responsaveis]="responsavel"
        [value]="responsibleID"
        (valueChange)="responsibleID = $event"
        placeholder="Selecione o responsável"
        placeholderBusca="Buscar responsável"
        [class.form-input--error]="campoObrigatorioErro && !responsibleID"
      ></app-filtro-responsavel>
      <span class="error-msg" *ngIf="campoObrigatorioErro && !responsibleID">Selecione o responsável</span>
    </div>

    <div class="form-group">
      <label class="form-label" for="tarefa">
        Selecionar tarefa <span class="required">*</span>
      </label>
      <select
        id="tarefa"
        [(ngModel)]="actionID"
        class="form-select"
        [class.form-input--error]="campoObrigatorioErro && !actionID"
      >
        <option value="" disabled>Selecione a tarefa</option>
        <option *ngFor="let r of tarefas" [value]="r.id">{{ r.description }}</option>
      </select>
      <span class="error-msg" *ngIf="campoObrigatorioErro && !actionID">Selecione a tarefa</span>
    </div>

    <div class="form-row form-row--data">
      <div class="form-group">
        <label class="form-label" for="data">
          Data <span class="required">*</span>
        </label>
        <input
          id="data"
          type="date"
          [(ngModel)]="data"
          class="form-input"
          [min]="today"
          [class.form-input--error]="campoObrigatorioErro && !data"
        />
        <span class="error-msg" *ngIf="campoObrigatorioErro && !data">Informe a data</span>
      </div>
      <div class="form-group">
        <label class="form-label" for="hora">
          Hora <span class="required">*</span>
        </label>
        <input
          id="hora"
          type="time"
          [(ngModel)]="hora"
          class="form-input"
          [class.form-input--error]="campoObrigatorioErro && !hora"
        />
        <span class="error-msg" *ngIf="campoObrigatorioErro && !hora">Informe a hora</span>
      </div>
    </div>

    <div class="form-group">
      <label class="form-label" for="taskDescription">Descreva a tarefa</label>
      <textarea
        id="taskDescription"
        [(ngModel)]="description"
        class="form-textarea"
        rows="3"
        maxlength="2000"
        [class.form-input--error]="campoObrigatorioErro && !description"
        placeholder="Adicione informações sobre a tarefa..."
      ></textarea>
      <div class="textarea-footer">
        <span class="char-count">{{ description.length }}/2000</span>
      </div>
      <span class="error-msg" *ngIf="campoObrigatorioErro && !description">Campo obrigatório!</span>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn-secondary" type="button" (click)="fechar()">
      Cancelar
    </button>
    <button class="btn-primary" type="button" (click)="criarTarefa()">
      <mat-icon>add</mat-icon>
      Agendar tarefa
    </button>
  </div>
</div>
